import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "dataFilter"
})

export class DataFilterPipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            query = query.toLowerCase();
            return _.filter(array, row =>
                row.Name && row.Name.toLowerCase().indexOf(query) > -1 ||
                row.OrganizationNumber && row.OrganizationNumber.toLowerCase().indexOf(query) > -1 ||
                row.Phone && row.Phone.toLowerCase().indexOf(query) > -1 ||
                row.Email && row.Email.toLowerCase().indexOf(query) > -1 ||
                row.AppName && row.AppName.toLowerCase().indexOf(query) > -1 ||
                row.CompanyName && row.CompanyName.toLowerCase().indexOf(query) > -1 ||
                row.Category && row.Category.toLowerCase().indexOf(query) > -1 ||
                row.Modules && row.Modules.toLowerCase().indexOf(query) > -1 ||
                row.Address && row.Address.toLowerCase().indexOf(query) > -1 ||
                row.CategoryName && row.CategoryName.toLowerCase().indexOf(query) > -1 ||
                row.UserName && row.UserName.toLowerCase().indexOf(query) > -1 ||
                row.Created && row.Created.toLowerCase().indexOf(query) > -1 ||
                row.LastActivity && row.LastActivity.toLowerCase().indexOf(query) > -1 ||
                row.UserRole && row.UserRole.toLowerCase().indexOf(query) > -1 ||
                row.Title && row.Title.toLowerCase().indexOf(query) > -1 ||
                row.Description && row.Description.toLowerCase().indexOf(query) > -1 ||
                row.Unit && row.Unit.toLowerCase().indexOf(query) > -1 ||
                row.PublishedDate && row.PublishedDate.toLowerCase().indexOf(query) > -1 ||
                row.Author && row.Author.toLowerCase().indexOf(query) > -1 ||
                row.EventStartDate && row.EventStartDate.toLowerCase().indexOf(query) > -1 ||
                row.EventEndDate && row.EventEndDate.toLowerCase().indexOf(query) > -1 ||
                row.IOSVersion && row.IOSVersion.toLowerCase().indexOf(query) > -1 ||
                row.IOSPublished && row.IOSPublished.toLowerCase().indexOf(query) > -1 ||
                row.AndroidVersion && row.AndroidVersion.toLowerCase().indexOf(query) > -1 ||
                row.ContactName && row.ContactName.toLowerCase().indexOf(query) > -1 ||
                row.Message && row.Message.toLowerCase().indexOf(query) > -1 ||
                row.SendDate && row.SendDate.toLowerCase().indexOf(query) > -1 ||
                row.DepartmentName && row.DepartmentName.toLowerCase().indexOf(query) > -1 ||
                row.AndroidPublished && row.AndroidPublished.toLowerCase().indexOf(query) > -1 ||
                row.UserUnit && row.UserUnit.toLowerCase().indexOf(query) > -1 ||
                row.UnitName && row.UnitName.toLowerCase().indexOf(query) > -1 ||
                row.CheckInDate && row.CheckInDate.toLowerCase().indexOf(query) > -1 || 
                row.FullName && row.FullName.toLowerCase().indexOf(query) > -1 || 
                row.Sender && row.Sender.toLowerCase().indexOf(query) > -1
            );
        }
        return array;
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/shared/elements/data-filter.pipe.ts